import Isotope from "isotope-layout";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import p1 from "../../../assets/images/all-img/portfolio/p1.png";
import p2 from "../../../assets/images/all-img/portfolio/p2/p2.png";
import p3 from "../../../assets/images/all-img/portfolio/p2/p3.png";
import p4 from "../../../assets/images/all-img/portfolio/p2/p4.png";
import p5 from "../../../assets/images/all-img/portfolio/p2/p5.png";
import p6 from "../../../assets/images/all-img/portfolio/p2/p6.png";
import arrowRightBlack from "../../../assets/images/svg/arrow-black-right.svg";

export default function FilterGallaryThree() {
	const isotope = useRef();
	const [activeClass, setActiveClass] = useState("*");
	const [filterKey, setFilterKey] = useState("*");
	useEffect(() => {
		setTimeout(() => {
			isotope.current = new Isotope("#fugu-gallery-masonay2", {
				itemSelector: ".fugu-grid-item",
				masonry: {
					columnWidth: ".fugu-grid-item",
					gutterWidth: 0,
				},
				resizable: false,
			});
		}, 1000);
		return () => isotope.current.destroy();
	}, []);

	useEffect(() => {
		if (isotope.current)
			filterKey === "*"
				? isotope.current.arrange({ filter: `*` })
				: isotope.current.arrange({ filter: `.${filterKey}` });
	}, [filterKey]);

	const handleFilterKeyChange = (key) => () => {
		setFilterKey(key);
		setActiveClass(key);
	};

	const handleActiveClass = (key) => {
		if (key === activeClass) return "active";
	};

	return (
		<div className="section fugu-section-padding">
			<div className="container">
				<div className="fugu-gallery-menu ">
					<ul id="watch-filter-gallery" className="option-set clear-both">
						<li onClick={handleFilterKeyChange("*")} className={handleActiveClass("*")}>
							All Projects (35)
						</li>
						<li onClick={handleFilterKeyChange("branding")} className={handleActiveClass("branding")}>
							Branding (10)
						</li>
						<li onClick={handleFilterKeyChange("commercial")} className={handleActiveClass("commercial")}>
							Commercial (08)
						</li>
						<li onClick={handleFilterKeyChange("digital")} className={handleActiveClass("digital")}>
							Digital Art (12)
						</li>
						<li onClick={handleFilterKeyChange("design")} className={handleActiveClass("design")}>
							UI/UX Design (05)
						</li>
					</ul>
				</div>
				<div className="fugu-gallery-wrap row" id="fugu-gallery-masonay2">
					<div
						className="fugu-grid-item col-lg-6 col-sm-12 branding commercial wow fadeInUpX"
						data-wow-delay="0s"
					>
						<div className="fugu-gallery-item item2">
							<img src={p1} alt="" />
							<div className="fugu-gallery-data2">
								<h4>
									<Link to={"/single-portfolio"}> Artwork wall printing </Link>
								</h4>
								<p>Digital Art</p>
								<Link to="single-portfolio"  >
									<a className="fugu-icon-btn">
										Discover More <img src={arrowRightBlack} alt="" />
									</a>
								</Link>
							</div>
						</div>
					</div>
					<div className="fugu-grid-item col-lg-6 col-sm-12 commercial wow fadeInUpX" data-wow-delay=".10s">
						<div className="fugu-gallery-item item2">
							<img src={p2} alt="" />
							<div className="fugu-gallery-data2">
								<h4>
									<Link to={"/single-portfolio"}> Skeleton face </Link>
								</h4>
								<p>Branding</p>
								<Link to="single-portfolio"  >
									<a className="fugu-icon-btn">
										Discover More <img src={arrowRightBlack} alt="" />
									</a>
								</Link>
							</div>
						</div>
					</div>
					<div className="fugu-grid-item col-lg-6 col-sm-12 design wow fadeInUpX" data-wow-delay=".20s">
						<div className="fugu-gallery-item item2">
							<img src={p3} alt="" />
							<div className="fugu-gallery-data2">
								<h4>
									<Link to={"/single-portfolio"}> Chinese ladyface </Link>
								</h4>
								<p>Commercial</p>
								<Link to="single-portfolio"  >
									<a className="fugu-icon-btn">
										Discover More <img src={arrowRightBlack} alt="" />
									</a>
								</Link>
							</div>
						</div>
					</div>
					<div
						className="fugu-grid-item col-lg-6 col-sm-12 digital design wow fadeInUpX"
						data-wow-delay=".30s"
					>
						<div className="fugu-gallery-item item2">
							<img src={p4} alt="" />
							<div className="fugu-gallery-data2">
								<h4>
									<Link to={"/single-portfolio"}> Primitive culture </Link>
								</h4>
								<p>Digital Art</p>
								<Link to="single-portfolio"  >
									<a className="fugu-icon-btn">
										Discover More <img src={arrowRightBlack} alt="" />
									</a>
								</Link>
							</div>
						</div>
					</div>
					<div
						className="fugu-grid-item col-lg-6 col-sm-12 branding commercial wow fadeInUpX"
						data-wow-delay=".40s"
					>
						<div className="fugu-gallery-item item2">
							<img src={p5} alt="" />
							<div className="fugu-gallery-data2">
								<h4>
									<Link to={"/single-portfolio"}> Strategic planning </Link>
								</h4>
								<p>Branding</p>
								<Link to="single-portfolio" className="fugu-icon-btn" >
									Discover More <img src={arrowRightBlack} alt="" />
								</Link>
							</div>
						</div>
					</div>
					<div className="fugu-grid-item col-lg-6 col-sm-12 commercial wow fadeInUpX" data-wow-delay=".50s">
						<div className="fugu-gallery-item item2">
							<img src={p6} alt="" />
							<div className="fugu-gallery-data2">
								<h4>
									<Link to={"/single-portfolio"}> Wild animal artwork </Link>
								</h4>
								<p>Digital Art</p>
								<Link to="single-portfolio"  >
									<a className="fugu-icon-btn">
										Discover More <img src={arrowRightBlack} alt="" />
									</a>
								</Link>
							</div>
						</div>
					</div>
				</div>
				<div className="fugu-portfolio-btn">
					<Link to={"#"}  >
						<a className="fugu-btn small-btn">View All</a>
					</Link>
				</div>
			</div>
		</div>
	);
}
